import { jarvisOnestockExistingHoldingConstants } from "./jarvisOnestockExistingHoldingConstants";

const jarvisOnestockExistingHoldingAction = {};

jarvisOnestockExistingHoldingAction.getExistingHoldingList = () => ({
    type: jarvisOnestockExistingHoldingConstants.ONESTOCK_EXISTING_HOLDING_SAGA,
});

export { jarvisOnestockExistingHoldingAction };
